import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { sections } from '../data/sections';
import { headlineMetrics, capitalMetrics } from '../data/metrics';
const section = sections[4];
export function ImpactMetrics() {
  return <div data-id="element-225" data-mp="2b14k3ixqn7ef">
      <PageHeader section={section} intro="The measurable footprint of a career spent deploying public and private capital into industrial capability." data-id="element-226" data-mp="2ayia7cndkft1" />

      <div className="mt-12 grid gap-px bg-navy-600 sm:grid-cols-2" data-id="element-227" data-mp="1id8pcjrqbpka">
        {headlineMetrics.map(metric => <article key={metric.label} className="relative flex flex-col bg-navy pattern-grid p-9 lg:p-11" data-id="element-228" data-mp="1nba3qre7n0pf">
            <p className="font-serif text-5xl leading-none text-gold lg:text-6xl" data-id="element-229" data-mp="1x0k0ikk017jv">
              {metric.value}
            </p>
            <h2 className="mt-6 font-serif text-xl leading-snug text-white" data-id="element-230" data-mp="zkeea0x88hlc">
              {metric.label}
            </h2>
            <p className="mt-auto pt-4 text-[14px] leading-relaxed text-slate-400" data-id="element-231" data-mp="14ioe4otwc6da">
              {metric.detail}
            </p>
          </article>)}
      </div>

      <h2 className="mt-14 text-[11px] font-semibold uppercase tracking-overline text-slateink-light" data-id="element-232" data-mp="3vger63f7zk4y">
        Capital, scale and stewardship
      </h2>
      <dl className="mt-6 grid gap-px border border-slate-200 bg-slate-200 sm:grid-cols-2 lg:grid-cols-3" data-id="element-233" data-mp="3qmakll9v9e4e">
        {capitalMetrics.map(metric => <div key={metric.label} className="flex h-full flex-col bg-white p-7" data-id="element-234" data-mp="3horsxy1pw1jj">
            <dt className="font-serif text-3xl leading-none text-navy" data-id="element-235" data-mp="3com74yi4p99d">
              {metric.value}
            </dt>
            <dd className="mt-4 flex flex-1 flex-col" data-id="element-236" data-mp="37qkdjjn2trjn">
              <span className="text-[13px] font-semibold text-navy" data-id="element-237" data-mp="33oh0iqkreew9">
                {metric.label}
              </span>
              <span className="mt-auto pt-2 text-[12px] leading-relaxed text-slateink-light" data-id="element-238" data-mp="15yph2b9e5tm0">
                {metric.detail}
              </span>
            </dd>
          </div>)}
      </dl>
    </div>;
}